import * as focusTrap from 'focus-trap';
import { KEYS, KEYS_DIRECTION } from '../constants';

class MakeHeaderAccessible {
  constructor({ dom, handlePrimaryNavTriggerClick, closePrimaryNavChildMenu }) {
    this.dom = {
      ...dom
    }

    this.handlePrimaryNavTriggerClick = handlePrimaryNavTriggerClick;
    this.closePrimaryNavChildMenu = closePrimaryNavChildMenu;
    this.init();
    this.addListeners();
    this.initiateFocusTrap();
  }

  addListeners() {
    this.dom.$primaryNavTriggers._on('keydown', this.handlePrimaryNavKeyDown.bind(this));
    this.dom.$primaryNavTriggers._on('keyup', this.handlePrimaryNavKeyUp.bind(this));
    this.dom.$closeHamburger?._on('keydown', this.handleHamburguerCloseNavKeyDown.bind(this));
    this.dom.$hamburgerMenu?._on('keydown', this.handleHamburguerMenuNavKeyDown.bind(this));
  }

  init() {
    this.dom.$primaryNavTriggers.forEach((el, i) => el.dataset.index = i)
  }

  handleHamburguerCloseNavKeyDown(e) {

    if (e.keyCode === KEYS.TAB) {
      this.dom.$hamburgerMenu.focus();
    }
    if (e.keyCode === KEYS.ESC) {

      this.dom.$closeHamburger.click()
      this.dom.$hamburger.focus();
    }
  }

  handleHamburguerMenuNavKeyDown(e) {
    const innerLinks = this.dom.$hamburgerMenu.getElementsByTagName('a')
    const firstLink = innerLinks[0]

    if (e.shiftKey && e.keyCode === KEYS.TAB && (firstLink === e.target)) {
      this.dom.$closeHamburger.focus()
    }

    if (e.keyCode === KEYS.ESC) {
      this.dom.$closeHamburger.click()
      this.dom.$hamburger.focus();
    }
  }


  handlePrimaryNavKeyDown(e) {

    switch (e.keyCode) {
    case KEYS.END:
      this.focusPrimaryNavOnKeyPress(this.dom.$primaryNavTriggers[this.dom.$primaryNavTriggers.length - 1]);
      break;
    case KEYS.HOME:
      e.preventDefault();
      this.focusPrimaryNavOnKeyPress(this.don.$primaryNavTriggers[0]);
      break;
    case KEYS.DOWN:
    case KEYS.ENTER:
      e.preventDefault();
      this.handlePrimaryNavTriggerClick(e);
      this.panelFocusTrap.activate();
      break
    }
  }

  handlePrimaryNavKeyUp(e) {
    if (KEYS.RIGHT || KEYS.ENTER) {
      this.focusPrimaryNavOnKeyPress(e);
    }
  }

  focusPrimaryNavItem(item) {
    this.blurPrimaryNavItems();
    item.removeAttribute('tabindex');

    item.focus();
  }

  blurPrimaryNavItems() {
    this.dom.$primaryNavTriggers.forEach(link => {
      link.setAttribute('tabindex', '-1');
    });
  }

  focusPrimaryNavOnKeyPress(e) {
    if (!KEYS_DIRECTION[e.keyCode]) return;
    if (typeof e.target.dataset.index === 'undefined') return;
    const index = parseInt(e.target.dataset.index, 10);

    if (this.dom.$primaryNavTriggers[index + KEYS_DIRECTION[e.keyCode]]) {
      this.focusPrimaryNavItem(this.dom.$primaryNavTriggers[index + KEYS_DIRECTION[e.keyCode]]);
      return;
    }

    if (e.keyCode === KEYS.left) {
      this.focusPrimaryNavItem(this.dom.$primaryNavTriggers[this.dom.$primaryNavTriggers.length - 1]);
    } else if (e.keyCode === KEYS.right) {
      this.focusPrimaryNavItem(this.dom.$primaryNavTriggers[0]);
    }
  }

  initiateFocusTrap() {
    this.panelFocusTrap = focusTrap.createFocusTrap(this.dom.$childNavWrapper, {
      onDeactivate: this.closePrimaryNavChildMenu,
      allowOutsideClick: false,
      initialFocus: () => {
        return this.dom.$childNavWrapper._$('.primary-nav__child-menu--opened').getElementsByTagName('A')[0]
      }
    });
  }
}

export default MakeHeaderAccessible;
